module.exports = __webpack_public_path__ + "static/media/add_images.2f3a2d3a.png";